module.exports = __webpack_public_path__ + "components/home-header/static/header-7--huge@2x-8589344a93190e51a92626742aebb09a.jpg";